import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import {
	LoginIcon,
	UserGroupIcon,
	ClipboardCheckIcon,
	ExclamationCircleIcon } from '@heroicons/react/outline'

const TONES = {
	blue: { tile: 'bg-blue-50', icon: 'text-blue-600' },
	emerald: { tile: 'bg-emerald-50', icon: 'text-emerald-600' },
	indigo: { tile: 'bg-indigo-50', icon: 'text-indigo-600' },
	rose: { tile: 'bg-rose-50', icon: 'text-rose-600' },
	slate: { tile: 'bg-slate-100', icon: 'text-slate-500' }
}

class TodayOverview extends Component {
	_gridClass = (count) => {
		return "grid grid-cols-1 gap-4 sm:grid-cols-2 " + ((count >= 4) ? "lg:grid-cols-4" : "lg:grid-cols-3")
	}

	_renderSkeleton = () => {
		const count = (this.props.showTodo === false) ? 3 : 4
		const placeholders = (count >= 4) ? [1, 2, 3, 4] : [1, 2, 3]
		return (
			<div className={this._gridClass(count)}>
				{placeholders.map(key => {
					return (
						<div key={key} className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5 animate-pulse">
							<div className="flex items-center justify-between mb-4">
								<div className="h-3 bg-slate-100 rounded-full w-2/3"></div>
								<div className="w-9 h-9 bg-slate-100 rounded-xl"></div>
							</div>
							<div className="h-8 bg-slate-200 rounded-lg w-1/3"></div>
						</div>
					)
				})}
			</div>
		)
	}

	_renderCard = (card) => {
		const tone = TONES[(card.alert === true) ? 'rose' : card.tone] || TONES.slate
		const Icon = card.icon
		const content = (
			<>
				<div className="flex items-center justify-between">
					<span className="text-2xs font-bold text-slate-400 uppercase tracking-widest">{card.label}</span>
					<div className={'w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 ' + tone.tile}>
						<Icon className={'w-5 h-5 ' + tone.icon} aria-hidden="true" />
					</div>
				</div>
				<p className="text-3xl font-black text-slate-900 mt-2 mb-0 leading-none">{card.value}</p>
				{card.sub &&
					<p className={'mt-2 mb-0 text-xs truncate ' + ((card.alert === true) ? 'text-rose-600 font-bold' : 'text-slate-400 font-semibold')}>{card.sub}</p>
				}
			</>
		)
		if (card.to)
		{
			return (
				<Link
					key={card.label}
					to={card.to}
					className={'block bg-white border rounded-2xl shadow-sm p-5 cursor-pointer transition-all hover:shadow-md hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-indigo-500 ' + ((card.alert === true) ? 'border-rose-200' : 'border-slate-200')}
				>
					{content}
				</Link>
			)
		}
		return (
			<div key={card.label} className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5">
				{content}
			</div>
		)
	}

	render() {
		if (this.props.loading === true)
			return this._renderSkeleton()
		const arrivals = this.props.arrivals
		const onsite = this.props.onsite
		const todo = this.props.todo
		const cards = [
			{
				icon: LoginIcon,
				tone: 'blue',
				label: 'Arrivées aujourd\'hui',
				value: arrivals.count,
				sub: (arrivals.count === 0) ? 'Aucune arrivée prévue' : null,
				to: '/checkins/arrivals'
			},
			{
				icon: UserGroupIcon,
				tone: 'emerald',
				label: 'Présents sur site',
				value: onsite.people,
				sub: onsite.stays + ' séjour' + ((onsite.stays > 1) ? 's' : '') + ' en cours, d\'après votre PMS',
				to: null
			},
			{
				icon: ClipboardCheckIcon,
				tone: 'indigo',
				label: 'Pré check-ins du jour',
				value: arrivals.precheckinsDone + ' / ' + arrivals.count,
				sub: (arrivals.precheckinsMissing > 0) ? arrivals.precheckinsMissing + ' à relancer' : ((arrivals.count > 0) ? 'Tous complétés' : 'Rien à relancer'),
				alert: arrivals.precheckinsMissing > 0,
				to: '/checkins/arrivals'
			}
		]
		// "À traiter" : affichée seulement si un module l'alimente (commandes,
		// avis, interventions). Sinon "0 / Tout est à jour" serait trompeur.
		if (this.props.showTodo !== false)
		{
			cards.push({
				icon: ExclamationCircleIcon,
				tone: 'slate',
				label: 'À traiter',
				value: todo.total,
				sub: (todo.total > 0) ? todo.detail : 'Tout est à jour',
				alert: todo.total > 0,
				to: todo.to
			})
		}
		return (
			<div className={this._gridClass(cards.length)}>
				{cards.map(card => this._renderCard(card))}
			</div>
		)
	}
}

export default TodayOverview
